import EditorField from 'builder/components/EditorField'
import { TextField } from 'builder/components/TextField'
import { useWorkExperienceCardContext } from '../../ExpandableCardContext'
import { useShokumuTranslations } from '../../useShokumuTranslations'

const Capital = (): JSX.Element => {
  const {
    item: { employerProfilesAttributes },
    onCardValueChange,
  } = useWorkExperienceCardContext()

  const { i18n } = useShokumuTranslations()
  const label = i18n('work_experience.employer_details.capital')

  const updateCapital = (e: React.ChangeEvent<HTMLInputElement>) => {
    onCardValueChange(
      { employerProfilesAttributes: { ...employerProfilesAttributes, capital: e.target.value } },
      true,
    )
  }

  return (
    <EditorField>
      <TextField
        label={label}
        name="capital"
        onChange={updateCapital}
        value={employerProfilesAttributes?.capital || ''}
      />
    </EditorField>
  )
}
export default Capital
